/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agb_Dispute_Resolution_TitleInputs */

const en_agb_dispute_resolution_title = /** @type {(inputs: Agb_Dispute_Resolution_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6b. Dispute Resolution`)
};

const de_agb_dispute_resolution_title = /** @type {(inputs: Agb_Dispute_Resolution_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6b. Streitbeilegung`)
};

const fr_agb_dispute_resolution_title = /** @type {(inputs: Agb_Dispute_Resolution_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6b. Reglement des litiges`)
};

const es_agb_dispute_resolution_title = /** @type {(inputs: Agb_Dispute_Resolution_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6b. Resolucion de disputas`)
};

const it_agb_dispute_resolution_title = /** @type {(inputs: Agb_Dispute_Resolution_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6b. Risoluzione delle controversie`)
};

const nl_agb_dispute_resolution_title = /** @type {(inputs: Agb_Dispute_Resolution_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6b. Geschillenbeslechting`)
};

const pl_agb_dispute_resolution_title = /** @type {(inputs: Agb_Dispute_Resolution_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6b. Rozstrzyganie sporow`)
};

const fi_agb_dispute_resolution_title = /** @type {(inputs: Agb_Dispute_Resolution_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6b. Riidanratkaisu`)
};

const da_agb_dispute_resolution_title = /** @type {(inputs: Agb_Dispute_Resolution_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6b. Tvistlosning`)
};

const sv_agb_dispute_resolution_title = /** @type {(inputs: Agb_Dispute_Resolution_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6b. Tvistlosning`)
};

/**
* | output |
* | --- |
* | "6b. Dispute Resolution" |
*
* @param {Agb_Dispute_Resolution_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const agb_dispute_resolution_title = /** @type {((inputs?: Agb_Dispute_Resolution_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agb_Dispute_Resolution_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_agb_dispute_resolution_title(inputs)
	if (locale === "fr") return fr_agb_dispute_resolution_title(inputs)
	if (locale === "es") return es_agb_dispute_resolution_title(inputs)
	if (locale === "it") return it_agb_dispute_resolution_title(inputs)
	if (locale === "nl") return nl_agb_dispute_resolution_title(inputs)
	if (locale === "pl") return pl_agb_dispute_resolution_title(inputs)
	if (locale === "fi") return fi_agb_dispute_resolution_title(inputs)
	if (locale === "da") return da_agb_dispute_resolution_title(inputs)
	if (locale === "sv") return sv_agb_dispute_resolution_title(inputs)
	return en_agb_dispute_resolution_title(inputs)
});